import { v4 as uuidv4 } from 'uuid';

import {
  InvoicingDefaultLateMaxDaysTypeEnum,
  TaskType,
} from '__generated__/GQL';

import { FullTasksFormSchema } from './form/tasksForm.schema';

export const DEFAULT_LATE_MAX_DAYS = 30;
export const DEFAULT_LATE_MAX_DAYS_TYPE =
  InvoicingDefaultLateMaxDaysTypeEnum.Thirty;
export const QUOTE_VALIDITY_DAYS_UNLIMITED = -1;
export const REMINDER_MAX_OCCURRENCES_UNLIMITED = -1;

export const INVOICE_NUMBER_ARTICLE =
  'https://www.shine.fr/blog/factures-numerotation/';
export const QUOTE_NUMBER_ARTICLE =
  'https://help.shine.fr/fr/articles/4119056-comment-numeroter-mes-devis';

export const MINIMUM_LATE_FEE_FALLBACK = 14.76;

export const SIXTY_DAYS_LIMIT = 60;

export const createEmptyTask = () =>
  ({
    invoiceCatalogItemId: null,
    invoiceTaskId: uuidv4(),
    subtitle: '',
    title: '',
    type: TaskType.Service,
    unitPrice: 0,
    units: 1,
    vatPercentage: 0,
  }) satisfies FullTasksFormSchema;
